import { useContext } from 'react';
import { CalendarContext } from '../../context/CalendarContext/context';

function useSelectedCalendarArtists() {
  const { selectedCalendarArtists, setSelectedCalendarArtists } =
    useContext(CalendarContext);
  return [selectedCalendarArtists, setSelectedCalendarArtists] as const;
}

export default useSelectedCalendarArtists;
